<template>
    <div
        :class="[
            'relative-block',
            layout.type, type,
            `count-${related.length}`,
            { block: type === 'default' }
        ]"
    >
        <div class="row">
            <h3 v-if="type === 'slim'">
                <IconPlus/>{{layout.title || (layout.type === 'technique' ? $t('common.relatedtechniques') : $t('common.relatedprojects'))}}
            </h3>
            <h2 v-else-if="type === 'default'">{{layout.title || $t('common.implementationmethods')}}</h2>
            <div class="column-list" v-if="layout.type === 'story'">
                <component
                    :key="post.id"
                    :is="`block-${layout.type}`"
                    v-for="post in related"
                    :post="post"
                >
                </component>
            </div>
            <div class="related-list" v-else-if="type === 'slim'">
                <component
                    :key="post.id"
                    :is="`block-${layout.type}`"
                    v-for="post in related"
                    :post="post"
                >
                </component>
            </div>
            <div v-else class="related-list">
                <div>
                    <component
                        :key="post.id"
                        :is="`block-${layout.type}`"
                        v-for="post in highlightRelated"
                        :post="post"
                    >
                    </component>
                </div>
                <div>
                    <component
                        :key="post.id"
                        :is="`block-${layout.type}`"
                        v-for="post in baseRelated"
                        :post="post"
                    >
                    </component>
                </div>
            </div>
        </div>
        <div class="footer" v-if="layout.hascta">
            <Cta
                v-if="layout.hascta"
                :type="'router-link'"
                :to="$trl({
                    name: layout.cta.link
                })"
                class="link"
            >   {{layout.cta.caption}}
            </Cta>
        </div>
    </div>
</template>

<script>
import IconPlus from '@/components/IconPlus'
import BlockTechnique from '@/components/layout/RelativeBlock/BlockTechnique'
import BlockProject from '@/components/layout/RelativeBlock/BlockProject'
import BlockMethod from '@/components/layout/RelativeBlock/BlockMethod'
import BlockStory from '@/components/layout/RelativeBlock/BlockStory'
import Cta from '@/components/Cta'

const Layouts = {
    technique: {
        type: 'slim'
    },
    project: {
        type: 'slim'
    },
    story: {
        type: 'column'
    },
    method: {
        type: 'default'
    }
}
export default {
    components: {
        IconPlus,
        BlockTechnique,
        BlockProject,
        BlockMethod,
        BlockStory,
        Cta
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    },
    computed: {
        type() {
            const { type } = this.layout
            return Layouts[type] ? Layouts[type].type : 'default'
        },
        related() {
            let res = []
            if(this.layout.mode === 'last' && this.layout.posts) {
                return this.layout.posts
            } else if(this.$parent.page.related_posts) {
                res = this.$parent.page.related_posts
                    .filter(_ => _.type === this.layout.type)
                if(this.type !== 'default') {
                    res = res.slice(0, this.layout.count ? parseInt(this.layout.count) : 3)
                }
            }
            return res
        },
        baseRelated() {
            return this.related.filter(_ => !_.highlight)
        },
        highlightRelated() {
            return this.related.filter(_ => _.highlight)
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.relative-block
    overflow: hidden
    @media print
        page-break-inside: avoid
        break-inside: avoid
        overflow: visible
        margin-top: 1.2cm
        margin-bottom: 1.2cm
    &.slim
        justify-content: space-between
        margin-top: 8.25%
        padding-left: 10.41667%
        padding-right: 10.41667%
        @include media-breakpoint-down($hd)
            flex-direction: column
            margin-left: 72 / 750 * 100%
            margin-right: 72 / 750 * 100%
            padding-left: 0
            padding-right: 0
        margin-bottom: 10%
        @media print
            margin-top: 1.2cm
            margin-bottom: 1.2cm
    &.default
        margin-top: 10%
        margin-bottom: 10%
        @media print
            margin-top: 1.2cm
            margin-bottom: 1.2cm
    &+.relative-block
        border-top: 1px solid #cccccc
        padding-top: 10%
        &.slim
            padding-top: 8.25%
.row
    display: flex
    flex-wrap: wrap
    flex: 1
h3
    font-size: 86px
    color: #ff2b2a
    font-weight: 500
    line-height: 1.2
    // max-width: 35%
    position: relative
    margin-bottom: 6.25%
    @include media-breakpoint-down($lg)
        max-width: initial
        margin-left: 52px
    @include media-breakpoint-down($sm)
        font-size: 28px
        margin-left: 0
    @media print
        margin-left: 0
        font-size: 28px
    svg
        position: absolute
        right: 100%
        margin-right: .4em
        top: .6em
        transform: translateY(-50%)
        @include media-breakpoint-down($sm)
            width: 20px
            height: 20px
            display: none
        @media print
            display: none
    /deep/ path
        fill: #ff2b2a
h2
    font-size: 86px
    color: #636772
    font-weight: 500
    letter-spacing: -0.03125em
    line-height: 1.0465116279
    margin-bottom: 8%
    @include media-breakpoint-down($lg)
        font-size: 70px
    @include media-breakpoint-down($sm)
        font-size: 28px
        margin-left: 0
    svg
        @include media-breakpoint-down($sm)
            display: none
    @media print
        font-size: 35px
        margin-bottom: .6cm
.related-list
    flex-wrap: wrap
    .slim &
        display: inline-flex
        margin-left: auto
        @include media-breakpoint-down($lg)
            flex-direction: column
            margin-left: 0
            width: 100%
    .slim.technique.count-3 &
            margin-top: 6.4%
.column-list
    display: flex
    max-width: 910px
    width: 100%
    margin-left: auto
    margin-right: auto
    margin-bottom: 14%
    flex-direction: column
.footer
    margin-left: auto
    width: 460px
    align-items: center
    justify-content: center
    display: flex
    margin-top: 6%
    @include media-breakpoint-down($lg)
        width: auto
    @media print
        width: auto
        display: block
        margin-top: .6cm
.cta
    border: 1px solid #e5e5e5
    @media print
        position: relative
        overflow: visible
        border: none
        &:after
            content: "https://www.soletanche-bachy.com" attr(href)
            font-size: 12px
            font-weight: normal
</style>
